import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { NavLink } from 'react-router-dom';

export default class NavBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isWorkOpened: props.showWork
    }
  }

  toggleCollapse(isWorkOpened) {
    this.setState({
      isWorkOpened: isWorkOpened
    })
  }

  capitalize(word) {    
    return word.charAt(0).toUpperCase() + word.substring(1);
  }

  render()
  {
    var workOptions = ['people', 'products', 'personal'];

    return (
      <ul className='nav-bar'>
        <li>
          <NavLink exact
            activeClassName='active-link'
            to='/work'
          >
            Work
          </NavLink>
          <Collapse isOpened={this.props.showWork}>
            <ul className='work-list'>
              {workOptions.map((option) => {
                return (
                  <li key={option}>
                    <NavLink 
                      activeClassName='active-link'
                      to={'/work/' + option}
                      onClick={() => this.props.toggleWork(true)} 
                      >
                      {'▪ ' + this.capitalize(option)}
                    </NavLink>
                  </li>
                )
              })}
            </ul>
          </Collapse>
        </li>
        <li>
          <NavLink exact
            activeClassName='active-link'
            to='/clients'
            onClick={() => this.toggleCollapse(false)}
          >
            Clients
          </NavLink>
        </li>
        <li>
          <NavLink exact
            activeClassName='active-link'
            to='/contact'
            onClick={() => this.toggleCollapse(false)}
          >
            Contact
          </NavLink>
        </li>
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar.js